var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActiveCheckR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 4,
  fill: "#003399"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.36664 12.1L14.0166 6.45C14.15 6.31667 14.3055 6.25 14.4833 6.25C14.6611 6.25 14.8166 6.31667 14.95 6.45C15.0833 6.58333 15.15 6.74178 15.15 6.92533C15.15 7.10889 15.0833 7.26711 14.95 7.4L8.83331 13.5333C8.69998 13.6667 8.54442 13.7333 8.36664 13.7333C8.18887 13.7333 8.03331 13.6667 7.89998 13.5333L5.03331 10.6667C4.89998 10.5333 4.83598 10.3751 4.84131 10.192C4.84664 10.0089 4.9162 9.85044 5.04998 9.71667C5.18376 9.58289 5.3422 9.51622 5.52531 9.51667C5.70842 9.51711 5.86664 9.58378 5.99998 9.71667L8.36664 12.1Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgActiveCheckR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/active-check-r.45e55f7fbe5985a64174ddfe7f7985cd.svg";